const Navbar = () => {
    return ( 
        <div className="Navbar">
            <header>
                <div className="row">
                    <div className="col-4">
                        <h1 className="app-name pt-3 m-3 mb-0 pb-0">
                            <em>A</em>
                            <em>T</em>
                            <em>M</em>
                            <em className="planet left">o</em>
                            <em className="px-1">S</em>
                            <em className="planet right" style={{color:"transparent"}}>o</em>
                        </h1>
                    </div>
                    <div className="col-4"></div>

                    <div className="col-4">
                        <h4 className="text sub-head mx-auto pt-3 m-3 pr-5 justify-content-end" >The Weather App</h4>
                    </div>
               </div>
            </header>
        </div>
     );
}
 
export default Navbar;